import React from 'react';
import { GridNormalCell } from './GridNormalCell';
export function gridNormalCell(config) {
    return function normalCellRenderer(_a) {
        var rowData = _a.rowData, column = _a.column, rowIndex = _a.rowIndex, cellIndex = _a.cellIndex, disabled = _a.disabled, inactive = _a.inactive;
        return (React.createElement(GridNormalCell, { content: config.value(rowData), justify: column.justify, columnWidth: column.width, disabled: disabled, inactive: inactive, key: "text-cell-" + rowIndex + "-" + cellIndex + "-" + column.id }));
    };
}
//# sourceMappingURL=cell.js.map